<template>
  <div class="card card-chat-booking float-left ml-3"
       v-if="message.template.type === 'buttons'">
    <div class="card-header" v-if="message.template.titile">
      {{ message.template.titile }}
    </div>
    <div class="card-body">
      <div class="mb-3">
        <b>{{ message.template.text }}</b>
      </div>
      <div :class="{'pt-3' : index > 0}" v-for="action, index in message.template.actions">
        <button class="btn"
                :class="action.style"
                @click="sendMessage(action)">{{ action.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { signOut } from 'firebase/auth'
  import axios from 'axios'
  import { firebaseAuth } from '../../../helpers/firebaseHelpers'

  export default {
    props: {
      message: Object
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    methods: {
      confirmLogout (item) {
        this.$swal({
          title: this.$i18n.t('message.confirm.title'),
          text: this.$i18n.t('message.confirm.confirm_logout'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.no')
        }).then(() => {
          signOut(firebaseAuth).then(() => {
            const submitData = {
              user_id: this.user.id,
              token: null,
              platform: 'website'
            }
            const url = 'auth/logout'
            axios.post(url, submitData)
              .then(res => {
                const response = res.data
                if (!response.error) {
                  this.$store.commit('auth/SET_USER', null)
                  this.$store.commit('auth/SET_TOKEN', null)
                  // Logout clear booking data
                  this.$store.commit('booking/SET_PRE_BOOKING_DATA', null)
                  this.$store.commit('booking/SET_USER_PLACE_DATA', null)
                  this.$store.commit('payment/SET_PAYMENT_DETAIL', null)
                  const message = {
                    sender_type: 'user',
                    type: 'text',
                    label: item.label,
                    text: item.text
                  }
                  this.$store.commit('chatBooking/ADD_MESSAGE', message)
                }
              })
              .catch(error => {
                console.log('error', error)
              })
          }).catch((error) => {
            // An error happened.
            console.log(error)
          })
        })
      },
      sendMessage (item) {
        const itemType = item.type
        switch (itemType) {
          case 'message':
            const message = {
              sender_type: 'user',
              type: 'text',
              label: item.label,
              text: item.text
            }
            if (item.data) {
              message.data = item.data
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
            break
          case 'uri':
            window.open(item.uri, '_blank')
            break
          case 'confirm':
            if (item.label === 'logout') {
              this.confirmLogout(item)
            }
            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/TemplateMessage.vue